<script setup>
import { defineProps } from "vue";
defineProps(["customer", "editable"]);
</script>
<template>
  <div class="box">
    <header>Company Information</header>
    <div class="grid grid-flow-col">
      <label>Company</label>
      <span v-if="!editable">{{ customer.company }}</span>
      <input v-else :value="customer.company" />
      <label>Website</label>
      <span>{{ customer.website }}</span>
      <label>Supplier Reference</label>
      <span>{{ customer.supplier }}</span>
    </div>
  </div>

  <div class="box">
    <header>Payment Terms</header>
    <div class="grid grid-flow-col">
      <label>Terms</label>
      <span>Immediate Payment</span>
      <label>Discount</label>
      <span>0%</span>
    </div>
  </div>

  <div class="box">
    <header>Address</header>
    {{ customer.addresses }}
  </div>

  <div class="box">
    <header>Contacts</header>
    <div class="grid grid-cols-5 gap-2">
      <b>Name</b>
      <b>Position / Title</b>
      <b>Mobile Number</b>
      <b>Landline Number</b>
      <b>Email Address</b>
      <template v-for="contact in customer.contacts" :key="contact.id">
        <input type="text" :value="contact.name" />
        <input type="text" :value="contact.title" />
        <input type="text" :value="contact.mobile" />
        <input type="text" :value="contact.landline" />
        <input type="text" :value="contact.email" />
      </template>
    </div>
  </div>

  <div class="box">
    <header>Notes</header>
    {{ customer.notes }}
  </div>
</template>
